/**
 * @file util
 * @description some utility functions
 */ "use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "isResWritable", {
    enumerable: true,
    get: function() {
        return isResWritable;
    }
});
function isResWritable(res) {
    return !(!res || res.headersSent === true);
}
